import { render, staticRenderFns } from "./Blocking.vue?vue&type=template&id=4d1a1516"
import script from "./Blocking.vue?vue&type=script&lang=ts"
export * from "./Blocking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports